import React from 'react';

interface GrosymLogoProps {
  className?: string;
  color?: string;
  size?: number;
  showBg?: boolean;
  href?: string;
}

export const GrosymLogo: React.FC<GrosymLogoProps> = ({
  className = '',
  size = 32,
  showBg = false,
  href = '/',
}) => {
  const content = (
    <div
      className={`relative inline-flex items-center justify-center shrink-0 transition-transform duration-150 hover:scale-105 ${
        showBg ? 'rounded-2xl overflow-hidden shadow-sm border border-orange-500/20 bg-white p-1' : 'bg-transparent'
      } ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src={`${import.meta.env.BASE_URL}brand/grosym-isotipo.png`}
        alt="Grosym"
        width={size}
        height={size}
        className="block h-full w-full object-contain"
        draggable={false}
      />
    </div>
  );

  if (href) {
    return (
      <a
        href={href}
        title="Ir a la página principal de Grosym"
        aria-label="Ir a la página principal de Grosym"
        className="inline-flex items-center cursor-pointer transition-opacity hover:opacity-90"
      >
        {content}
      </a>
    );
  }

  return content;
};
